export const environment = {
  production: true,
  buildId: '3643060861522931',
  configFile: 'config.json',
};
